export const FETCHING_ITEMS = "FETCHING_MOVIE_CINEMA_CONSUMPTIONS";
export const FETCHED_ITEMS = "FETCHED_MOVIE_CINEMA_CONSUMPTIONS";
export const RECEIVED_ITEMS = "RECEIVED_MOVIE_CINEMA_CONSUMPTIONS";
export const FETCHING_MORE_ITEMS = "FETCHING_MORE_MOVIE_CINEMA_CONSUMPTIONS";
export const FETCHED_MORE_ITEMS = "FETCHED_MORE_MOVIE_CINEMA_CONSUMPTIONS";
export const RECEIVED_MORE_ITEMS = "RECEIVED_MORE_MOVIE_CINEMA_CONSUMPTIONS";
export const UPDATED_FILTERS = "UPDATED_MOVIE_CINEMA_CONSUMPTION_FILTERS";
export const REPLACED_FILTERS = "REPLACED_MOVIE_CINEMA_CONSUMPTION_FILTERS";
